import { render, staticRenderFns } from "./Left-top-Box.vue?vue&type=template&id=6797ea06&scoped=true&"
import script from "./Left-top-Box.vue?vue&type=script&lang=js&"
export * from "./Left-top-Box.vue?vue&type=script&lang=js&"
import style0 from "./Left-top-Box.vue?vue&type=style&index=0&id=6797ea06&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6797ea06",
  null
  
)

export default component.exports